import type { ComponentType } from 'react';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export function closeModal() {
  return {
    type: CLOSE_MODAL,
    payload: null,
  };
}

export function openModal<T extends Record<string, unknown>>(
  modalComponent: ComponentType<T>,
  modalProps: T
) {
  return {
    type: OPEN_MODAL,
    payload: {
      modalComponent,
      modalProps,
    },
  };
}
